import React from 'react';

export function applyMaskPhone(string) {
  const digits = string.replace(/\D/g, '');
  if (digits.length === 11) {
    return digits.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  }
  return digits.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
}

export function applyMaskCellPhone(string) {
  return string
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{4})\d+?$/, '$1');
}

export function cpfMask(value) {
  if (!value) return '';

  return value
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1');
}

export function removeCpfMask(value: string): string {
  if (!value) return '';
  return value.replace(/\D/g, '');
}

export function applyMaskCnpj(string) {
  if (string.length === 14) {
    const regex = /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/;

    return string.replace(regex, '$1.$2.$3/$4-$5');
  }
}

export function applyMaskPostalCode(string: string): string {
  return string
    .replace(/\D/g, '')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{3})\d+?$/, '$1');
}

export function phoneTwoMaskDynamic(v) {
  // const digits = v ? removeMask(v) : '';
  const digits = v ? v : '';
  const cut = digits.length === 10 ? 6 : 7;
  const max = digits.length > 11 ? 11 : digits.length;

  if (digits.length > 2 && digits.length < 10) {
    return `(${digits.substring(0, 2)}) ${digits.substring(
      2,
      cut,
    )}${digits.substring(cut, max)}`;
  }
  if (digits.length >= 10) {
    return `(${digits.substring(0, 2)}) ${digits.substring(
      2,
      cut,
    )}-${digits.substring(cut, max)}`;
  }

  return digits;
}

export const dateMask = (value) => {
  const digits = String(value ?? '')
    .replaceAll(/\D/g, '')
    .slice(0, 8);
  const day = digits.slice(0, 2);
  const month = digits.slice(2, 4);
  const year = digits.slice(4, 8);
  if (digits.length <= 2) return day;
  if (digits.length <= 4) return `${day}/${month}`;
  return `${day}/${month}/${year}`;
};

export const handleDateInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  const input = event.target;
  const oldValue = input.value;
  const oldCursorPosition = input.selectionStart || 0;
  
  const digitsBeforeCursor = oldValue.substring(0, oldCursorPosition).replace(/\D/g, '').length;
  const newValue = dateMask(oldValue);
  
  let newCursorPosition = 0;
  let digitCount = 0;
  
  for (let i = 0; i < newValue.length; i++) {
    if (/\d/.test(newValue[i])) {
      digitCount++;
      if (digitCount > digitsBeforeCursor) {
        newCursorPosition = i;
        break;
      }
      newCursorPosition = i + 1;
    }
  }
  
  if (digitCount <= digitsBeforeCursor) {
    newCursorPosition = newValue.length;
  }
  
  input.value = newValue;
  
  requestAnimationFrame(() => {
    input.setSelectionRange(newCursorPosition, newCursorPosition);
  });
};

export const cepMask = (value) => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{3})\d+?$/, '$1');
};

function addThousandSeparators(intPart: string): string {
  if (!intPart) return intPart;
  let result = '';
  for (let i = 0; i < intPart.length; i++) {
    if (i > 0 && (intPart.length - i) % 3 === 0) {
      result += '.';
    }
    result += intPart[i];
  }
  return result;
}

export const moneyMask = (value) => {
  const digits = value.replace(/\D/g, '');
  if (!digits) return '';

  const withComma = digits.replace(/(\d)(\d{1,2})$/, '$1,$2');
  const commaIdx = withComma.indexOf(',');
  const intPart = commaIdx === -1 ? withComma : withComma.slice(0, commaIdx);
  const decPart = commaIdx === -1 ? '' : withComma.slice(commaIdx);

  return `${addThousandSeparators(intPart)}${decPart}`;
};

export const rgMask = (value = '') => {
  let v = value?.replace(/\D/g, '');
  v = v?.replace(/(\d{1,2})(\d{3})(\d{3})(\d{1})$/, '$1.$2.$3-$4');

  return v;
};

const cardDefaultFormat = /(\d{1,4})/g;

const cardsMap = [
  {
    type: 'amex',
    pattern: /^3[47]/,
    format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
    length: [15],
    cvcLength: [4],
    luhn: true,
    mask: '9999 999999 99999',
  },
  {
    type: 'master',
    pattern:
      /^(5[1-5]|677189)|^(222[1-9]|2[3-6]\d{2}|27[0-1]\d|2720)|^2[2-7][0-9]{14}$/,
    format: cardDefaultFormat,
    length: [16],
    cvcLength: [3],
    luhn: true,
    mask: '9999 9999 9999 9999',
  },
  {
    type: 'visa',
    pattern: /^4/,
    format: cardDefaultFormat,
    length: [13, 16, 19],
    cvcLength: [3],
    luhn: true,
    mask: '9999 9999 9999 9999',
  },
];

export const cardFromNumber = (num) => {
  let card, j, len;
  num = `${num}`.replace(/\D/g, '');
  for (j = 0, len = cardsMap.length; j < len; j++) {
    card = cardsMap[j];
    if (card.pattern.test(num)) {
      return card;
    }
  }
};

export const formatDate = (date: string) => {
  const [day, month, year] = date.split('/');
  return `${year}-${month}-${day}`;
};

export const unformatDate = (date: string) => {
  const [year, month, day] = date.split('-');
  return `${day}/${month}/${year}`;
};
